import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApi from "../../../services/auth/useApi";
import { AxiosError } from "axios";
import { CreateSpaceType, SpaceIdType, SpaceType, UpdateSpaceType } from "../../../types/space";
import { SpaceStatus } from "../../../types/space/enum";
import { spaceQueryKeys } from "../queries";

export const patchSpaceApi = async (
  api: ReturnType<typeof useApi>,
  projectId: SpaceIdType,
  payload: Partial<CreateSpaceType>
): Promise<SpaceType> => {
  const response = await api.patch(`/spaces/${projectId}`, payload);

  return response.data;
};

export const useUpdateArchivedSpaceMutation = () => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<SpaceType, AxiosError, { id: SpaceIdType; payload: Partial<UpdateSpaceType> }>(
    {
      mutationFn: ({ id, payload }) => patchSpaceApi(api, id, payload),
      onMutate: async ({ id, payload }) => {
        await queryClient.cancelQueries({
          queryKey: spaceQueryKeys.status(SpaceStatus.Completed),
        });

        queryClient.setQueryData(
          spaceQueryKeys.status(SpaceStatus.Completed),
          (oldData: SpaceType[]) => {
            if (!oldData) return [];
            return oldData.map((space) => (space.id === id ? { ...space, ...payload } : space));
          }
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: spaceQueryKeys.status(SpaceStatus.Completed),
        });
      },
    }
  );
};
